import { render, staticRenderFns } from "./recommendManage.vue?vue&type=template&id=0f353f45&scoped=true"
import script from "./recommendManage.vue?vue&type=script&lang=js"
export * from "./recommendManage.vue?vue&type=script&lang=js"
import style0 from "./recommendManage.vue?vue&type=style&index=0&id=0f353f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f353f45",
  null
  
)

export default component.exports